import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppButton } from 'owa-command-ribbon';
import { showEditorSettings } from 'owa-editor-proofing-common';
import GrammarCheck from 'owa-fluent-icons-svg/lib/icons/TextGrammarCheckmarkFilled';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import type { IButtonStyles } from '@fluentui/react';
import { ActionControlId } from 'owa-ribbon-ids';
import loc from 'owa-localize';
import { proofingOptionsText } from '../../utils/actionControlStrings.locstring.json';
import { getHoverTooltip } from '../../utils/HoverTooltips/getHoverTooltip';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';

const onShowEditorSettings = (viewState: EditorViewState, isDisabled: boolean) => {
    return () => {
        if (viewState) {
            if (!isDisabled) {
                const targetWindow = callEditorApi(viewState, 'getDocument')?.defaultView || window;
                showEditorSettings(viewState, targetWindow)();
            }
        }
    };
};

export const getProofingOptions = computedFn(
    (
        viewState: EditorViewState,
        isDisabled: boolean,
        styles: IButtonStyles | undefined
    ): RibbonControlProps => {
        const label = loc(proofingOptionsText);
        return createAppButton(
            getComposeRibbonId(ActionControlId.ProofingOptions, viewState),
            label,
            onShowEditorSettings(viewState, isDisabled),
            undefined /* keytipProps */,
            GrammarCheck,
            undefined /* iconColor */,
            styles,
            {
                customTooltip: getHoverTooltip(ActionControlId.ProofingOptions, label),
            }
        );
    }
);
